import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../Store/Actions'
import useReactRouter from 'use-react-router';
import MaterialTable from 'material-table';
import axios from '../../../Helpers/Axiosbase'
import { LinearProgress,Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

export default function AppsList() {
    // Material Table Configuration
    const [columns] = React.useState([
        { title: "Display Name", field: "displayName" },
        { title: "App Context Code", field: "appContextCode" },
        { title: "Display Sequence", field: "displaySequence" },
        { title: "Is Active?", field: "isActive", type: "boolean" },
        { title: "Created On", field: "createDate", type: "date" },
       
        // { title: "Display Sequence", field: 1}
    ]);

    // Setting up States
    const [state, setState] = React.useState({
        showProgress: true,
        appsData: []
    });

    const [errorMessage,setErrorMessage]=React.useState({
        open:false,
        errmsg:null,
      });
      const [deleteInfoMsg,setDeleteInfoMsg] = React.useState({
        open:false,
        infoMsg:''
    })

      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setDeleteInfoMsg({
          open:false,
          infoMsg:''
      })
      };

      const handleDeleteApp = (rowData) =>{
        let url = "appDelete"
        let postdata = { _id:rowData._id, token: reduxAuth.token, userId: reduxAuth.userId }
        // console.log(postdata);
        // console.log(rowData);
        axios.post(url, postdata)
            .then(response => {
              setDeleteInfoMsg({
                open:true,
                infoMsg:'App Deleted Successfully!!'
            })
                getAllApp();
            })
            .catch(err => {
                if(typeof err.response!="object")
              {
                setErrorMessage({
                  open:true,
                  // errmsg:err
                })
                console.log(err);
              }
              else 
              {
                if (err.response.status === 403) {
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                }
              }
        });
    } 


    //Hooks Setup
    const reduxAuth = useSelector((state) => state.auth)
    const { history } = useReactRouter();
    const dispatch = useDispatch();

    const getAllApp = () =>{
      let url = "getAll"
      let postdata = { objectName: "app", token: reduxAuth.token, userId: reduxAuth.userId }
      axios.post(url, postdata)
          .then(response => {
              setState({ showProgress: false, appsData: response.data.response });
          })
          .catch(err => {
              if(typeof err.response!="object")
            {
              setErrorMessage({
                open:true,
                // errmsg:err
              })
              console.log(err);
            }
            else 
            {
              if (err.response.status === 403) {
                  setState({ showProgress: false, appsData: [] });
                  dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
              }
            }
          });
    }

    useEffect(() => {
       getAllApp();
    }, []);

    //Render Method
    return (
        <div>
             <Snackbar
                open={deleteInfoMsg.open} autoHideDuration={4000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="info"
                    color="info"
                    variant="outlined">
                    {deleteInfoMsg.infoMsg}
                    </Alert>
            </Snackbar>
            <Snackbar
                open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="error"
                    color="error"
                    variant="filled">
                    {errorMessage.errmsg!=null?errorMessage.errmsg:" NetWork Error:Please Check Your Internet Connection"}
                    </Alert>
            </Snackbar>
            {state.showProgress ? <LinearProgress /> : null}
            <MaterialTable
                title="Apps"
                columns={columns}
                data={state.appsData}
                editable={{
                  onRowDelete: oldData =>
                  new Promise(resolve => {
                    setTimeout(() => {
                      resolve();
                      handleDeleteApp(oldData);
                    }, 600);
                  }),
                }}
                actions={[
                    {
                        icon: 'edit',
                        tooltip: 'Edit App',
                        onClick: (event, rowData) => {
                            history.push('/apps/manage', rowData);
                        }
                    },
                    {
                        icon: 'add',
                        tooltip: 'Add App',
                        isFreeAction: true,
                        onClick: (event) => history.push("/apps/manage")
                    },
                ]}
            />
        </div>
    );
}